import { createSharedRoot } from '@bz/request';
import { useCurrency } from '@bz/common';
import Decimal from 'decimal.js-light';

export const useBonusConfig = createSharedRoot(() => {
  const { latestCurrency } = useCurrency();

  const bonusConfig = useResource(
    async (pre) => {
      if (account.isLogin) {
        const res = await get.getAccountConfigBetLimit({});
        return res;
      }
      return pre;
    },
    {
      initialValue: {
        minBet: 0,
        minBetOdds: 0,
        maxBet: 0,
        creditMaxBet: -1, // -1 代表不限制信用投注额
      },
    }
  );
  const [amountBet, setAmountBet] = createSignal(0);
  const isShowMinTips = () => bonusConfig().minBet > amountBet();
  const isShowMaxTips = () => bonusConfig().maxBet < amountBet();
  const minBetOdds = createMemo(() => {
    return bonusConfig().minBetOdds;
  });
  const min = createMemo(() => {
    const cfg = bonusConfig();
    return currency.convertCurrency(new Decimal(cfg.minBet), 'USDT', latestCurrency())?.toDecimalPlaces(2)?.toNumber();
  });
  const max = createMemo(() => {
    const cfg = bonusConfig();
    return currency.convertCurrency(new Decimal(cfg.maxBet), 'USDT', latestCurrency())?.toDecimalPlaces(2)?.toNumber();
  });
  const maxCreditBet = createMemo(() => {
    const cfg = bonusConfig();
    return currency
      .convertCurrency(new Decimal(cfg.creditMaxBet ?? -1), 'USDT', latestCurrency())
      ?.toDecimalPlaces(2)
      ?.toNumber();
  });
  return {
    minBet: min,
    maxBet: max,
    minBetOdds: minBetOdds,
    maxCreditBet: maxCreditBet,
    isShowMinTips,
    isShowMaxTips,
    setAmountBet,
  };
});
